import { getCurrentColor } from "common/utils/enhanced-url-generator";
import { getColorFromHash } from "common/utils/color-url-persist";

const ACTIVE_COLOR_QUERY_PARAM = "ac";

export const normalizeCompositionName = compositionName => {
  if (!compositionName) return "";

  const raw = compositionName.toString().replace(/\+/g, " ").trim();
  const withoutUrlSuffix = raw.split(/[?#]/)[0] || "";

  try {
    return decodeURIComponent(withoutUrlSuffix).trim().replace(/\s+/g, " ");
  } catch {
    return withoutUrlSuffix.trim().replace(/\s+/g, " ");
  }
};

export const getCompositionNameFromQueryParam = (queryParam = ACTIVE_COLOR_QUERY_PARAM) => {
  const urlParams = new URLSearchParams(window.location.search);
  const value = urlParams.get(queryParam);
  return value ? normalizeCompositionName(value) : "";
};

export const getCompositionNameFromLocation = (queryParam = ACTIVE_COLOR_QUERY_PARAM) => {
  const fromQueryParam = getCompositionNameFromQueryParam(queryParam);
  if (fromQueryParam) return fromQueryParam;

  // PIP-3358: canonical-URL surface carries color in the #color hash. Reading
  // is deliberately NOT flag-gated (only writing is): shared/bookmarked #color
  // links must keep resolving in flag-off sessions — mixed rollout states,
  // rollback, and the cache-TTL window after a toggle.
  const fromHash = normalizeCompositionName(getColorFromHash());
  if (fromHash) return fromHash;

  return normalizeCompositionName(getCurrentColor()?.color);
};

export const resolveCompositionName = ({
  containerSelectedColor,
  activeColorName,
  queryParam = ACTIVE_COLOR_QUERY_PARAM,
  preferQueryParam = false
} = {}) => {
  if (preferQueryParam) {
    const fromQueryParam = getCompositionNameFromQueryParam(queryParam);
    if (fromQueryParam) return fromQueryParam;
  }

  const fromContainer = normalizeCompositionName(containerSelectedColor);
  if (fromContainer) return fromContainer;

  const fromActiveElement = normalizeCompositionName(activeColorName);
  if (fromActiveElement) return fromActiveElement;

  return getCompositionNameFromLocation(queryParam);
};
